export const event = state => state.event;


export const training = state => state.training;
export const trainingGuests = state => state.trainingGuests;
export const companyGuests = state => state.companyGuests;

export const companyGuestsObject = (state) => {
  const localCompanyGuests = {};
  state.companyGuests.forEach((companyGuest) => {
    localCompanyGuests[companyGuest.id] = companyGuest;
  });

  return localCompanyGuests;
};

export const ceo = state => state.ceo;
